import { AccountFeatures, AppContext, Features } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Select from "react-select";
import GlobalHelper from "../../../../common/GlobalHelper.jsx";
import RichTextEditor from "../../../../common/rich-text/editor.component.jsx";
import SpanWrapper from '../../../../common/rich-text/feature-protection-wrappers/spanWrapper.component';
import { PAYMENT_TYPE } from "../../../../state/helpers/Payment";
import SectionContentTypes from "../ContentTypes.jsx";

class ApproveSectionContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        this.state = {
            className: this.props.className || '',
            variables: this.props.variables || {},
            onChange: this.props.onChange || function () { },
            hide: content.hide || false,
            acceptButtonText: content.acceptButtonText || '',
            declineButtonText: content.declineButtonText || '',
            allowDepositPayment: content.allowDepositPayment || false,
            forceSaveCard: content.forceSaveCard || false,
            checkBoxText: content.checkBoxText || '',
            allowSignature: content.allowSignature || false,
            firstName: content.firstName || '',
            lastName: content.lastName || '',
            allowPartialPayment: content.allowPartialPayment || false,
            defaultPaymentMethod: content.defaultPaymentMethod || 'credit-card',
            paymentMethods: content.paymentMethods || GlobalHelper.getPaymentMethods(),
            paymentMethodOptions: GlobalHelper.getPaymentMethodOptions(),
            hideAdditionalFeesMayApplyMessage: content.hideAdditionalFeesMayApplyMessage || false,
            hideComment: content.hideComment || false,
            hideAcceptButton: content.hideAcceptButton || false,
            hideDeclineButton: content.hideDeclineButton || false,
            acceptedCardBrands: content.acceptedCardBrands || [],
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handlePaymentMethods = this.handlePaymentMethods.bind(this)
        this.handleDefaultPaymentMethod = this.handleDefaultPaymentMethod.bind(this)
        this.handleAcceptedCardBrands = this.handleAcceptedCardBrands.bind(this)
        this.paymentMethodIsSelected = this.paymentMethodIsSelected.bind(this)
    }

    triggerChanged() {
        this.state.onChange({
            hide: this.state.hide,
            acceptButtonText: this.state.acceptButtonText,
            declineButtonText: this.state.declineButtonText,
            allowDepositPayment: this.state.allowDepositPayment,
            forceSaveCard: this.state.forceSaveCard,
            checkBoxText: this.state.checkBoxText,
            allowSignature: this.state.allowSignature,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            allowPartialPayment: this.state.allowPartialPayment,
            paymentMethods: this.state.paymentMethods,
            acceptedCardBrands: this.state.acceptedCardBrands,
            defaultPaymentMethod: this.state.defaultPaymentMethod,
            hideAdditionalFeesMayApplyMessage: this.state.hideAdditionalFeesMayApplyMessage,
            hideComment: this.state.hideComment,
            hideAcceptButton: this.state.hideAcceptButton,
            hideDeclineButton: this.state.hideDeclineButton,
        })
    }

    componentDidMount() {
        this.triggerChanged()
        if (this.state.variables && this.state.variables.quote) {
            this.setState({
                paymentMethodOptions: this.state.paymentMethodOptions.concat(
                    GlobalHelper.getAllStripeIntegrationsPaymentMethodOptions()
                )
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.value || {}
        this.setState({
            hide: content.hide || false,
            allowDepositPayment: content.allowDepositPayment || false,
            forceSaveCard: content.forceSaveCard || false,
            acceptButtonText: content.acceptButtonText || '',
            declineButtonText: content.declineButtonText || '',
            checkBoxText: content.checkBoxText || '',
            variables: nextProps.variables || {},
            allowSignature: content.allowSignature || false,
            firstName: content.firstName || '',
            lastName: content.lastName || '',
            allowPartialPayment: content.allowPartialPayment || false,
            defaultPaymentMethod: content.defaultPaymentMethod || 'credit-card',
            paymentMethods: content.paymentMethods || ['credit-card', 'bank-transfer'],
            acceptedCardBrands: content.acceptedCardBrands || [],
            hideAdditionalFeesMayApplyMessage: content.hideAdditionalFeesMayApplyMessage || false,
            hideComment: content.hideComment || false,
            hideAcceptButton: content.hideAcceptButton || false,
            hideDeclineButton: content.hideDeclineButton || false,
        })
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        }, this.triggerChanged)
    }

    handlePaymentMethods(paymentMethods) {
        if (paymentMethods.length === 0) {
            paymentMethods = [{ value: 'credit-card' }]
        }
        let state = {
            paymentMethods: paymentMethods.map(option => {
                return option.value
            })
        }
        if (paymentMethods.length === 1) {
            state.defaultPaymentMethod = paymentMethods[0].value
        }

        this.setState(state, this.triggerChanged)
    }

    handleDefaultPaymentMethod(paymentMethod) {
        this.setState({
            defaultPaymentMethod: paymentMethod.value,
        }, this.triggerChanged)
    }

    handleAcceptedCardBrands(acceptedCardBrands) {
        this.setState({
            acceptedCardBrands: acceptedCardBrands.map(option => option.value)
        }, this.triggerChanged)
    }

    paymentMethodIsSelected(paymentMethod) {
        return this.state.paymentMethods.includes(paymentMethod)
    }

    render() {
        const hasIntegratedPayment = AppContext.hasFeatureIntegration(Features.IntegratedPayment)
        const showAllowDepositPaymentOption = hasIntegratedPayment || GlobalHelper.hasShopifyIntegration()
        const showDepositPaymentOptions = hasIntegratedPayment && this.state.allowDepositPayment
        const showDefaultPaymentMethodOption = hasIntegratedPayment && this.state.allowDepositPayment && this.state.paymentMethods.length > 1

        return (
            <div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="acceptButtonText">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.approve_section.accept_button_label"
                            defaultMessage="Accept button text"
                        />
                    </label>

                    <div className="col-10">
                        <input
                            name="acceptButtonText"
                            value={this.state.acceptButtonText}
                            onChange={this.handleFormChange}
                            id="acceptButtonText"
                            type="text"
                            className="form-control"
                            placeholder={this.props.intl.formatMessage({ id: 'proposal.approve_btn' })}
                        />

                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.approve_section.accept_button_description"
                                defaultMessage="This text will replace the accept button text of the proposal"
                            />
                        </small>
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="declineButtonText">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.approve_section.decline_button_label"
                            defaultMessage="Decline button text"
                        />
                    </label>

                    <div className="col-10">
                        <input
                            name="declineButtonText"
                            value={this.state.declineButtonText}
                            onChange={this.handleFormChange}
                            id="declineButtonText"
                            placeholder={this.props.intl.formatMessage({ id: 'proposal.decline_btn' })}
                            type="text"
                            className="form-control"
                        />

                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.approve_section.decline_button_description"
                                defaultMessage="This text will replace the decline button text of the proposal"
                            />
                        </small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="checkBoxText">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.approve_section.checkbox_text_label"
                            defaultMessage="Checkbox text"
                        />
                    </label>

                    <div className="col-10">
                        <RichTextEditor
                            height={100}
                            enableMergeFields={true}
                            name="checkBoxText"
                            variables={this.state.variables}
                            value={this.state.checkBoxText}
                            onChange={t => this.setState({ checkBoxText: t }, this.triggerChanged)}
                            id="checkBoxText"
                            className="form-control"
                            colors={SectionContentTypes.getUniquesColorsFromVariables(this.state.variables)}
                        />

                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.approve_section.checkbox_text_description"
                                defaultMessage="This text will replace the text next to the checkbox"
                            />
                        </small>
                    </div>
                </div>
                <div className="row">
                    <div className="col-2" />

                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hide"
                                name="hide"
                                value={this.state.hide}
                                checked={this.state.hide}
                                onChange={this.handleFormChange}
                            />

                            <label className="custom-control-label" htmlFor="hide">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.approve_section.hide_label"
                                    defaultMessage="Hide completely the approve section"
                                />
                            </label>

                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.approve_section.hide_description"
                                    defaultMessage="This will hide the whole section on the proposal."
                                />
                            </small>
                        </div>
                    </div>
                </div>

                {showAllowDepositPaymentOption &&
                    <div className="row">
                        <div className="col-2" />

                        <div className="col-10">
                            <SpanWrapper
                                accountFeatureKey={AccountFeatures.FeatureRemovePaymentButton}
                                redirectToAccount={true}
                                showLock={false}>
                                <div className={'custom-control custom-checkbox ' +
                                    (AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureRemovePaymentButton) ? '' : 'text-muted')}>
                                    <input
                                        className="custom-control-input"
                                        type="checkbox"
                                        id="allowDepositPayment"
                                        name="allowDepositPayment"
                                        value={this.state.allowDepositPayment}
                                        checked={(AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureRemovePaymentButton) ?
                                            this.state.allowDepositPayment : true)}
                                        onChange={this.handleFormChange}
                                    />

                                    <label className="custom-control-label" htmlFor="allowDepositPayment">
                                        <FormattedMessage
                                            id="templates.sections.form.edit.content.approve_section.allow_deposit_payment_label"
                                            defaultMessage="Allow deposit payment"
                                        />
                                    </label>

                                    <small className={'form-text text-muted'} >
                                        <FormattedMessage
                                            id="templates.sections.form.edit.content.approve_section.allow_deposit_payment_description"
                                            defaultMessage="This will show the payment interface once the proposal is accepted. Customers will be able to pay the deposit online."
                                        />
                                    </small>
                                </div>
                            </SpanWrapper>
                        </div>
                    </div>
                }

                {showDepositPaymentOptions &&
                    <>
                        <div className="row">
                            <div className="col-2" />

                            <div className="col-10">
                                <div className="custom-control custom-checkbox">
                                    <input
                                        className="custom-control-input"
                                        type="checkbox"
                                        id="forceSaveCard"
                                        name="forceSaveCard"
                                        value={this.state.forceSaveCard}
                                        checked={this.state.forceSaveCard}
                                        onChange={this.handleFormChange}
                                    />

                                    <label className="custom-control-label" htmlFor="forceSaveCard">
                                        <FormattedMessage
                                            id="templates.sections.form.edit.content.payment_section.force_save_card_label"
                                            defaultMessage="Save card on file for all payments"
                                        />
                                    </label>

                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="templates.sections.form.edit.content.payment_section.force_save_card_description"
                                            defaultMessage="This will hide the save card checkbox and will save the card on file automatically."
                                        />
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div className="form-group row mt-2">
                            <label className="col-2 col-form-label text-align-right" htmlFor="payBalanceButtonText">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.payment_section.payment_methods_label"
                                    defaultMessage="Payment methods"
                                />
                            </label>

                            <div className="col-10">
                                <Select
                                    searchable={false}
                                    multi
                                    value={this.state.paymentMethods}
                                    onChange={this.handlePaymentMethods}
                                    options={this.state.paymentMethodOptions}
                                />

                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="templates.sections.form.edit.content.payment_section.payment_methods_description"
                                        defaultMessage="This is the list of payment methods your customer will be able to pay from."
                                    />
                                </small>
                            </div>
                        </div>
                    </>
                }

                {showDefaultPaymentMethodOption &&
                    <div className="form-group row">
                        <label className="col-2 col-form-label text-align-right" htmlFor="payBalanceButtonText">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.payment_section.default_payment_method_label"
                                defaultMessage="Default payment method"
                            />
                        </label>

                        <div className="col-10">
                            <Select
                                searchable={false}
                                clearable={false}
                                value={this.state.defaultPaymentMethod}
                                onChange={this.handleDefaultPaymentMethod}
                                options={this.state.paymentMethodOptions}
                            />

                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.payment_section.default_payment_method_description"
                                    defaultMessage="This will open the selected tab by default."
                                />
                            </small>
                        </div>
                    </div>
                }

                {this.paymentMethodIsSelected(PAYMENT_TYPE.CREDIT_CARD) && (
                    <div className="form-group row">
                        <label className="col-2 col-form-label text-align-right" htmlFor="acceptedCardBrands">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.payment_section.accepted_card_brands"
                                defaultMessage="Accepted Card Brands"
                            />
                        </label>
                        <div className="col-10">
                            <Select
                                name="acceptedCardBrands"
                                searchable={false}
                                multi
                                value={this.state.acceptedCardBrands}
                                onChange={this.handleAcceptedCardBrands}
                                options={GlobalHelper.getCardBrandOptions()}
                                placeholder={this.props.intl.formatMessage({
                                    id: 'templates.sections.form.edit.content.payment_section.card_brands_placeholder',
                                    defaultMessage: 'All'
                                })}
                            />
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.payment_section.card_brands_description"
                                    defaultMessage="This is the list of card brands your customer will be able to use for payment."
                                />
                            </small>
                        </div>
                    </div>
                )}

                {!GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() &&
                    <>
                        <div className="row">
                            <div className="col-2" />
                            <div className="col-10">
                                <div className="custom-control custom-checkbox">
                                    <input
                                        className="custom-control-input"
                                        type="checkbox"
                                        id="allowPartialPayment"
                                        name="allowPartialPayment"
                                        value={this.state.allowPartialPayment}
                                        checked={this.state.allowPartialPayment}
                                        onChange={this.handleFormChange}
                                    />
                                    <label className="custom-control-label" htmlFor="allowPartialPayment">
                                        <FormattedMessage
                                            id="templates.sections.form.edit.content.payment_section.allow_partial_payment_label"
                                            defaultMessage="Allow to edit payment amount for partial payment"
                                        />
                                    </label>
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="templates.sections.form.edit.content.payment_section.allow_partial_payment_description"
                                            defaultMessage="This will allow your customer to partially pay the balance by inputting an amount."
                                        />
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-2" />
                            <div className="col-10">
                                <div className="custom-control custom-checkbox">
                                    <input
                                        className="custom-control-input"
                                        type="checkbox"
                                        id="hideAdditionalFeesMayApplyMessage"
                                        name="hideAdditionalFeesMayApplyMessage"
                                        value={this.state.hideAdditionalFeesMayApplyMessage}
                                        checked={this.state.hideAdditionalFeesMayApplyMessage}
                                        onChange={this.handleFormChange}
                                    />
                                    <label className="custom-control-label" htmlFor="hideAdditionalFeesMayApplyMessage">
                                        <FormattedMessage
                                            id="templates.sections.form.edit.content.payment_section.hide_additional_fees_text"
                                            defaultMessage="Hide additional fees may apply message"
                                        />
                                    </label>
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="templates.sections.form.edit.content.payment_section.hide_additional_fees_text_description"
                                            defaultMessage="This will hide the message that additional fees may apply at checkout"
                                        />
                                    </small>
                                </div>
                            </div>
                        </div>
                    </>
                }

                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideComment"
                                name="hideComment"
                                value={this.state.hideComment}
                                checked={this.state.hideComment}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideComment">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.approve_section.hide_comment_label"
                                    defaultMessage="Hide comment text area"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.approve_section.hide_comment_description"
                                    defaultMessage="If hidden, the customer won't be able to leave a comment."
                                />
                            </small>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideAcceptButton"
                                name="hideAcceptButton"
                                value={this.state.hideAcceptButton}
                                checked={this.state.hideAcceptButton}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideAcceptButton">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.payment_section.hide_accept_button_text"
                                    defaultMessage="Hide the button to accept the quote."
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.payment_section.hide_accept_button_text_description"
                                    defaultMessage="The button to accept the quote will be hidden. If hidden, the customer will be able to pay the deposit without accepting the quote."
                                />
                            </small>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="hideDeclineButton"
                                name="hideDeclineButton"
                                value={this.state.hideDeclineButton}
                                checked={this.state.hideDeclineButton}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="hideDeclineButton">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.payment_section.hide_decline_button_text"
                                    defaultMessage="Hide the button to decline the quote"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.payment_section.hide_decline_button_description"
                                    defaultMessage="The button to decline the quote will be hidden."
                                />
                            </small>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-2" />
                    <div className="col-10">
                        <div className="custom-control custom-checkbox">
                            <input
                                className="custom-control-input"
                                type="checkbox"
                                id="allowSignature"
                                name="allowSignature"
                                value={this.state.allowSignature}
                                checked={this.state.allowSignature}
                                onChange={this.handleFormChange}
                            />
                            <label className="custom-control-label" htmlFor="allowSignature">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.approve_section.allow_signature_label"
                                    defaultMessage="Capture signature after acceptance"
                                />
                            </label>
                            <small className="form-text text-muted">
                                <FormattedMessage
                                    id="templates.sections.form.edit.content.approve_section.allow_signature_description"
                                    defaultMessage="This will show the signature pad once the proposal is accepted. Customers will be able to sign online."
                                />
                            </small>
                        </div>
                    </div>
                </div>


                {this.state.allowSignature ? <div className="form-group row mt-3">
                    <label className="col-2 col-form-label text-align-right" htmlFor="firstName">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.approve_section.signer_first_name_label"
                            defaultMessage="Signer's first name"
                        />
                    </label>
                    <div className="col-10">
                        <input
                            name="firstName"
                            value={this.state.firstName}
                            onChange={this.handleFormChange}
                            id="firstName"
                            type="text"
                            className="form-control"
                            placeholder={this.state.variables.customer.firstName}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.approve_section.signer_first_name_description"
                                defaultMessage="This name will pre-fill the signature signer's first name form"
                            />
                        </small>
                    </div>
                </div> : ''}
                {this.state.allowSignature ? <div className="form-group row">
                    <label className="col-2 col-form-label text-align-right" htmlFor="lastName">
                        <FormattedMessage
                            id="templates.sections.form.edit.content.approve_section.signer_last_name_label"
                            defaultMessage="Signer's last name"
                        />
                    </label>
                    <div className="col-10">
                        <input
                            name="lastName"
                            value={this.state.lastName}
                            onChange={this.handleFormChange}
                            id="lastName"
                            type="text"
                            className="form-control"
                            placeholder={this.state.variables.customer.lastName}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.approve_section.signer_last_name_description"
                                defaultMessage="This name will pre-fill the signature signer's last name form"
                            />
                        </small>
                    </div>
                </div> : ''}
            </div>
        );
    }
}

export default injectIntl(ApproveSectionContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/approve-section/input.component.jsx